"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ToastMessages_1 = __importDefault(require("../../../shared/ToastMessages"));
const projectStore_1 = require("../../projectStore");
function useToastMessages() {
    return (0, projectStore_1.useProjectSelector)((state) => state.messages);
}
function MapmakerProjectToastMessages() {
    const messages = useToastMessages();
    return (0, jsx_runtime_1.jsx)(ToastMessages_1.default, { messages: messages });
}
exports.default = MapmakerProjectToastMessages;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJQcm9qZWN0VG9hc3RNZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3Byb2plY3Qvc2hhcmVkL3RvYXN0cy9NYXBtYWtlclByb2plY3RUb2FzdE1lc3NhZ2VzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrRkFBMEQ7QUFDMUQscURBQThFO0FBRTlFLFNBQVMsZ0JBQWdCO0lBQ3ZCLE9BQU8sSUFBQSxpQ0FBa0IsRUFBQyxDQUFDLEtBQTJCLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUM3RSxDQUFDO0FBRUQsU0FBd0IsNEJBQTRCO0lBQ2xELE1BQU0sUUFBUSxHQUFHLGdCQUFnQixFQUFFLENBQUM7SUFDcEMsT0FBTyx1QkFBQyx1QkFBYSxJQUFDLFFBQVEsRUFBRSxRQUFRLEdBQUksQ0FBQztBQUMvQyxDQUFDO0FBSEQsK0NBR0MifQ==